/**
 * Renders the pagination component for navigating through pages.
 *
 * @param { Object }   totalPages              - Object containing total number of pages, onPageChange function, and current page.
 * @param { number }   totalPages.totalPages   - Total number of pages.
 * @param { Function } totalPages.onPageChange - Function to handle page change.
 * @param { number }   totalPages.currentPage  - Current page number.
 *
 * @return { JSX.Element } Rendered pagination component.
 */
const Pagination = ( { totalPages, onPageChange, currentPage } ) => {
	const MAX_PAGES = 5;
	const pages = [];

	if ( totalPages <= MAX_PAGES ) {
		for ( let i = 1; i <= totalPages; i++ ) {
			pages.push( i );
		}
	} else {
		const startPage = Math.max( 1, currentPage - 2 );
		const endPage = Math.min( totalPages, currentPage + 2 );
		if ( startPage > 1 ) {
			pages.push( 1 );
			if ( startPage > 2 ) {
				pages.push( '...' );
			}
		}
		for ( let i = startPage; i <= endPage; i++ ) {
			pages.push( i );
		}
		if ( endPage < totalPages ) {
			if ( endPage < totalPages - 1 ) {
				pages.push( '...' );
			}
			pages.push( totalPages );
		}
	}

	return (
		<div className="product-lookup__pagination">
			<button
				className="product-lookup__pagination-button"
				disabled={ currentPage === 1 }
				onClick={ ( ) => onPageChange( currentPage - 1 ) }
			>
				Previous
			</button>
			{ pages.map( ( page, index ) => (
				page === '...' ? (
					<span key={ index } className="product-lookup__pagination-ellipsis">...</span>
				) : (
					<button
						key={ index }
						className={ `product-lookup__pagination-button ${ currentPage === page ? 'active' : '' }` }
						onClick={ ( ) => onPageChange( page ) }
					>
						{ page }
					</button>
				)
			) ) }
			<button
				className="product-lookup__pagination-button"
				disabled={ currentPage === totalPages }
				onClick={ ( ) => onPageChange( currentPage + 1 ) }
			>
				Next
			</button>
		</div>
	);
};

export default Pagination;
